var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.4844 19.8125C79.0938 19.3281 80 19.7812 80 20.5469V52.5C80 56.6406 76.6406 60 72.5 60H7.5C3.35938 60 0 56.6406 0 52.5V20.5625C0 19.7812 0.890625 19.3438 1.51562 19.8281C5.01562 22.5469 9.65625 26 25.5938 37.5781C28.8906 39.9844 34.4531 45.0469 40 45.0156C45.5781 45.0625 51.25 39.8906 54.4219 37.5781C70.3594 26 74.9844 22.5312 78.4844 19.8125ZM40 40C43.625 40.0625 48.8438 35.4375 51.4688 33.5312C72.2031 18.4844 73.7812 17.1719 78.5625 13.4219C79.4688 12.7187 80 11.625 80 10.4688V7.5C80 3.35938 76.6406 0 72.5 0H7.5C3.35938 0 0 3.35938 0 7.5V10.4688C0 11.625 0.53125 12.7031 1.4375 13.4219C6.21875 17.1562 7.79688 18.4844 28.5312 33.5312C31.1562 35.4375 36.375 40.0625 40 40Z",
    fill: "#233B92"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.40209e9d86563a34bbd10b9319b59343.svg";
export { ForwardRef as ReactComponent };